import { RecommendedTagState } from 'common/types/state'
import { StateKey } from 'common/utils/flipState'
import { RecommendedTagParams } from 'common/types/params'
import { CommonState } from 'common/types'
import { fetchRecommendedTags } from 'common/services/recommendedTag'
import { RecommendedTag } from 'common/types/entities/mongo/recommendedTag'
import { isRecommendedTagShown } from 'common/constants'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: RecommendedTagState = {
  tags: [],
  selectedTag: null,
  page: 0,
  hasMore: false,
  totalCount: 0,
  params: {},
  cacheParam: null,
}

const FETCH = 'recommendedTag/FETCH'
const SELECT = 'recommendedTag/SELECT'

export const getSelectedTagName = (recommendedTagState: RecommendedTagState) => {
  if (recommendedTagState.selectedTag) return recommendedTagState.selectedTag.name
}

export const fetchRecommendedTag = (curState: StateKey, params: RecommendedTagParams | any, merged?: boolean) => async (
  dispatch,
  getState: () => CommonState,
) => {
  let newParams: RecommendedTagParams = params
  if (merged) {
    newParams = {
      ...getState().recommendedTag[curState].params,
      ...params,
    }
  }
  if (!isRecommendedTagShown(newParams.subVertical)) return

  const cacheParam = createCacheParam(FETCH, 'fetchRecommendedTag', { curState, newParams, merged })
  if (isCacheHit(getState().recommendedTag[curState], cacheParam)) {
    return
  }

  const recommendedTagState = await fetchRecommendedTags(newParams)
  const selectedTagIdx =
    newParams.selectedName &&
    recommendedTagState &&
    recommendedTagState.tags &&
    recommendedTagState.tags.findIndex(tag => tag.name === newParams.selectedName)

  const selectedTag =
    (selectedTagIdx > -1 &&
      recommendedTagState &&
      recommendedTagState.tags &&
      recommendedTagState.tags[selectedTagIdx]) ||
    null

  const state = {
    ...recommendedTagState,
    selectedTagIdx,
    selectedTag,
  }

  dispatch({
    curState,
    state,
    newParams,
    cacheParam,
    type: FETCH,
  })
}

export const selectRecommendedTag = (curState: StateKey, selectedTag: RecommendedTag) => {
  return {
    curState,
    selectedTag,
    type: SELECT,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...initialState,
        ...action.state,
        params: action.newParams,
        cacheParam: action.cacheParam,
      }
    case SELECT:
      return {
        ...state,
        selectedTag: action.selectedTag,
        cacheParam: null,
      }
    default:
      return state
  }
}

export default reducer
